import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { Formik } from 'formik';
import { object as YupObject, string as YupString } from 'yup';
import DialogConfirmation from 'components/theme/dialog-confirmation';
import { messages } from 'app-constants';

class FormContent extends Component {
  state = { openConfirmation: false };

  handleConfirmationClose = (confirmation) => {
    if (confirmation === 'ok') {
      this.props.onFormClose();
    }
    this.setState({ openConfirmation: false });
  };

  onCancel = () => {
    if (this.props.dirty) {
      this.setState({ openConfirmation: true });
    } else {
      this.props.onFormClose();
    }
  };

  onChange = (tagetName) => (e) => {
    this.props.handleChange(e);
    this.props.setFieldTouched(tagetName, true, false);
  };

  render() {
    const {
      values: { name },
      errors,
      touched,
      isSubmitting,
      isValid,
      submitForm,
      action
    } = this.props;

    const { openConfirmation } = this.state;
    return (
      <>
        {openConfirmation ? (
          <DialogConfirmation
            title="Add Application"
            cancelLabel="Continue"
            okLabel="Discard"
            open={openConfirmation}
            onClose={this.handleConfirmationClose}
          >
            Your changes are not saved. Closing this window will discard
            changes.
          </DialogConfirmation>
        ) : (
          ''
        )}

        <DialogContent>
          {action === 'add' && (
            <Typography variant="subtitle2" gutterBottom>
              {messages.DEFAULT_ADD_APPLICATION_NOTE}
            </Typography>
          )}

          <TextField
            autoFocus
            name="name"
            margin="normal"
            label="Name"
            placeholder="Enter application name"
            helperText={touched.name ? errors.name : ''}
            error={touched.name && Boolean(errors.name)}
            onChange={this.onChange('name')}
            value={name}
            required
            fullWidth
            variant="outlined"
            // InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={this.onCancel}
            color="secondary"
            name="cancel"
            data-testid="cancel-form"
          >
            Cancel
          </Button>
          <Button
            onClick={submitForm}
            color="primary"
            name="submit-application"
            disabled={!isValid || isSubmitting}
            variant="contained"
            data-testid="submit-form"
          >
            {action === 'add' ? 'Add' : 'Update'}
          </Button>
        </DialogActions>
      </>
    );
  }
}

export default function ApplicationFormWithFormik({
  onSubmit,
  onClose,
  action
}) {
  const initialValues = {
    name: ''
  };

  const validationObjectShape = {
    name: YupString()
      .required()
      .min(4)
      .max(30)
      .matches(
        new RegExp(/^[\w\s]*$/i),
        'Application name must be in alphanumeric w/ underscore.'
      )
      .trim()
      .strict(true)
      .label('Application Name')
  };

  const validationSchema = YupObject().shape(validationObjectShape);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      render={(formikProps) => (
        <FormContent {...formikProps} onFormClose={onClose} action={action} />
      )}
    />
  );
}
